import { useEffect, useRef, useState } from 'react';

const REVIEWS = [
  { name: 'Kayla D.', location: 'Gulfport, MS', stars: 5, text: 'All Done Roofing was wonderful to work with! The team was so friendly and made the whole process easy from start to finish. They did an excellent job, and my roof looks fantastic. Truly grateful for their hard work!', initials: 'KD' },
  { name: 'Tracy Galloway', location: 'Mississippi', stars: 5, text: 'The work was done excellently in a timely manner, and the crew was very thorough in completing the roofing work. I highly recommend All Done Roofing to anyone looking for quality craftsmanship.', initials: 'TG' },
  { name: 'Cleveland Shaw', location: 'Gulf Coast', stars: 5, text: 'I had an excellent experience with James at All Done Roofing LLC. His professionalism and expertise were evident from the start. Thorough inspection, detailed explanation, fair estimate. Highly recommended!', initials: 'CS' },
  { name: 'Glenda Jones', location: 'Mississippi', stars: 5, text: 'We selected All Done Roofing for our roof replacement and could not have been more pleased. The work was exceptional and customer service was excellent. We 100% recommend All Done Roofing!', initials: 'GJ' },
  { name: 'Robert Neadel', location: 'Gulf Coast', stars: 5, text: 'All Done Roofing LLC exceeded my expectations with their exceptional service and quality workmanship. Professional, courteous, and highly skilled. Completed on time and within budget.', initials: 'RN' },
  { name: 'Jan Hurtuk', location: 'Mississippi', stars: 5, text: 'I recently had the pleasure of working with James and All Done Roofing LLC. James was professional, knowledgeable, and efficient. Quality exceeded my expectations, on time and within budget.', initials: 'JH' },
];

export default function SectionTestimonials() {
  const [visible, setVisible] = useState(false);
  const [featured, setFeatured] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="testimonials" ref={ref} className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="absolute right-8 top-16 font-serif text-[200px] text-gray-50 leading-none select-none pointer-events-none hidden xl:block" style={{ lineHeight: 1 }}>&ldquo;</div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <div className={`mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-gold"></span>
            <span className="text-[11px] font-bold tracking-super uppercase text-gold">Client Reviews</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
            <h2 className="font-condensed font-bold text-5xl md:text-6xl text-charcoal uppercase leading-none">
              What Customers<br />
              <span className="font-serif font-normal italic text-gray-400 text-4xl md:text-5xl normal-case leading-tight">Are Saying</span>
            </h2>
            <div className="flex items-center gap-2 shrink-0">
              {[1,2,3,4,5].map(s => <i key={s} className="ri-star-fill text-gold text-lg"></i>)}
              <span className="text-sm text-gray-400 ml-2 font-light">5.0 on Google</span>
            </div>
          </div>
        </div>
        <div className={`mb-10 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="bg-cream rounded-lg p-8 md:p-12 relative overflow-hidden border border-gray-100">
            <div className="absolute top-6 right-8 font-serif text-[80px] text-gold/10 leading-none select-none" style={{ lineHeight: 1 }}>&ldquo;</div>
            <div className="flex gap-0.5 mb-5">
              {Array(5).fill(0).map((_, i) => <i key={i} className="ri-star-fill text-gold text-sm"></i>)}
            </div>
            <p className="font-serif italic text-xl md:text-2xl text-charcoal leading-relaxed mb-7 max-w-3xl">
              &ldquo;{REVIEWS[featured].text}&rdquo;
            </p>
            <div className="flex items-center gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-gold/15 shrink-0">
                <span className="font-bold text-gold text-sm">{REVIEWS[featured].initials}</span>
              </div>
              <div>
                <p className="font-semibold text-charcoal text-sm">{REVIEWS[featured].name}</p>
                <p className="text-gray-400 text-xs tracking-wider">{REVIEWS[featured].location}</p>
              </div>
              <div className="ml-auto flex items-center gap-1.5">
                <i className="ri-google-fill text-gray-300 text-lg"></i>
                <span className="text-[10px] text-gray-300 tracking-wider uppercase">Google Review</span>
              </div>
            </div>
          </div>
          <div className="flex gap-2 mt-4">
            {REVIEWS.map((_, i) => (
              <button key={i} onClick={() => setFeatured(i)}
                className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${i === featured ? 'w-8 bg-gold' : 'w-4 bg-gray-200 hover:bg-gray-300'}`}></button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <button key={i} onClick={() => setFeatured(i)}
              className={`text-left p-5 rounded-lg border transition-all duration-300 cursor-pointer group ${featured === i ? 'border-gold/40 bg-gold/5' : 'border-gray-100 bg-white hover:border-gray-200 hover:bg-gray-50'}`}>
              <div className="flex gap-0.5 mb-3">
                {Array(r.stars).fill(0).map((_, j) => <i key={j} className="ri-star-fill text-gold text-xs"></i>)}
              </div>
              <p className="text-gray-600 text-xs leading-relaxed mb-3 line-clamp-3 font-light">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gold/15 shrink-0">
                    <span className="font-bold text-gold text-[10px]">{r.initials}</span>
                  </div>
                  <div>
                    <p className="font-semibold text-charcoal text-xs">{r.name}</p>
                    <p className="text-gray-400 text-[10px]">{r.location}</p>
                  </div>
                </div>
                <i className="ri-google-fill text-gray-200 group-hover:text-gray-300 transition-colors"></i>
              </div>
            </button>
          ))}
        </div>
        <div className={`mt-12 pt-10 border-t border-gray-100 text-center transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-gray-400 text-sm font-light mb-5">Join hundreds of Gulf Coast homeowners and businesses who trust All Done Roofing.</p>
          <a href="#estimate" onClick={e => { e.preventDefault(); document.getElementById('estimate')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-3 bg-charcoal text-white font-bold text-[12px] tracking-widest uppercase px-10 py-4 rounded hover:bg-ink transition-colors cursor-pointer whitespace-nowrap">
            Get Your Free Estimate <i className="ri-arrow-right-line text-gold"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
